import CSSPlugin from 'gsap/CSSPlugin';
import TweenLite from 'gsap/TweenLite';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { LabelPosition as Position } from './Utils';

// Need to do this so that `CSSPlugin` is not dropped by the minifier:
/* tslint:disable-next-line:no-unused-expression */
CSSPlugin;

const Element = styled.div`
  width: 1px;
  background-color: #666;
  position: absolute;
  transform: translateX(-50%);
`;

const lineTipDistanceFromChartEdge = 5;

interface Props {
  position: Position;
  chartHeight: number;
  tipX: number;
  tipY: number;
}

const Line = (props: Props) => {
  const {
    position, chartHeight,
    tipX, tipY,
  } = props;
  const delay = 0.5;
  let initialStyle: React.CSSProperties, cssTween: object;
  if (position === Position.Top) {
    initialStyle = {
      top: `${-lineTipDistanceFromChartEdge}px`,
      left: `${tipX}px`,
      bottom: `${chartHeight + lineTipDistanceFromChartEdge}px`,
    };
    cssTween = {
      css: { bottom: `${chartHeight - tipY}px`},
      delay,
    };
  } else {
    initialStyle = {
      bottom: `${-lineTipDistanceFromChartEdge}px`,
      left: `${tipX}px`,
      top: `${lineTipDistanceFromChartEdge + chartHeight}px`,
    };
    cssTween = {
      css: { top: `${tipY}px`},
      delay,
    };
  }
  const elRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
        const {current: el} = elRef;
        if (el !== null) {
          TweenLite.to(el, 1, cssTween);
        }
  });
  return (
    <Element style={initialStyle} ref={elRef}/>
  );
};

export default Line;
